var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    d: "M16.5459 12.763C16.5699 10.893 17.5499 9.16603 19.1429 8.18703C18.1339 6.74503 16.5029 5.86403 14.7439 5.80903C12.8929 5.61503 11.0989 6.91603 10.1559 6.91603C9.19487 6.91603 7.74287 5.82803 6.17887 5.86003C4.12187 5.92703 2.24987 7.06803 1.24887 8.86703C-0.882128 12.557 0.706872 17.981 2.74887 20.964C3.77087 22.425 4.96387 24.056 6.52687 23.999C8.05587 23.936 8.62687 23.024 10.4719 23.024C12.2999 23.024 12.8359 23.999 14.4299 23.962C16.0699 23.935 17.1039 22.495 18.0899 21.02C18.8239 19.979 19.3889 18.829 19.7629 17.612C17.8149 16.788 16.5479 14.879 16.5459 12.763Z",
    fill: "#1b4458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    d: "M13.5348 3.847C14.4288 2.773 14.8698 1.393 14.7628 0C13.3968 0.144 12.1338 0.797 11.2278 1.829C10.3328 2.848 9.87883 4.18 9.96683 5.534C11.3518 5.548 12.6668 4.926 13.5348 3.847Z",
    fill: "#1b4458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.be4b827ad1ae6743c59a78c93fdd6766.svg";
export { ForwardRef as ReactComponent };